export default __webpack_public_path__ + "static/media/JSCircularBackground-light-sepia-200px.jpg.806a3c55.webp";